import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    initialState: {
        isLoggingOut: false as boolean
    },

    name: 'useLogout',

    reducers: {
        isLoggingOut: (state, action) => {
            state.isLoggingOut = action.payload;
        }
    }
});

export default slice.reducer;
